import {  userObject, env } from './GeneralReducers';
import {combineReducers} from 'redux';

const rootReducer = combineReducers({
  userObject:userObject,
})

export default rootReducer;